import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { projectConfig } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

 public apiURL: string = projectConfig.apiURL;

  constructor(private http: HttpClient) { }

 public user_role = localStorage.getItem('user');
 public user_id = localStorage.getItem('user_id');
 public username = localStorage.getItem('user_name');



  public role = new BehaviorSubject<number>(0);
  currentData = this.role.asObservable();

  private serachdata = new BehaviorSubject<any>('');
  initialData = this.serachdata.asObservable();

  changeData(data: number) {
    this.role.next(data);
  }

  serachData(data: any) {
    this.serachdata.next(data)
  }

  getModel() {
    const url = this.apiURL + 'prompt_master_data/models';
    return this.http.get<any>(url);
  }

  getAllCreatore() {
    const url = this.apiURL + 'user_management/get_all_creators';
    return this.http.get<any>(url);
  }

  getSuggetion(searchtext: any) {
    const url = this.apiURL + 'prompt_manager/prompts_suggestion?search_text=' + searchtext + '&user_id=' + this.user_id + '&role=' + this.user_role;
    return this.http.get<any>(url);
    // http://localhost:8000/api/v1/prompt_manager/prompts_suggestion?search_text=testing
  }

  getSelectedRole(){
    return this.role;
  }

  promptDeleteApi(promptId: any) {
    const url = this.apiURL + 'prompt_manager/delete_prompt?prompt_id=' + promptId; 
    return this.http.delete<any>(url);
    // http://localhost:8000/api/v1/prompt_manager/prompts_suggestion?search_text=testing
  }

}
